module.exports = __webpack_public_path__ + "static/m-RCruz-baabe5bade9d7baddde787767f068096.jpg";